<template>
  <collapse-default :id="'endereco-casamento'"
                    :collapse-visible="collapseVisible"
                    :condition="!!local && !!local.endereco">
    <template v-slot:header>
      Local do Casamento  {{ local && !local.endereco ? ' - Nenhum informado' : '' }}
    </template>
    <template v-slot:content>
      <div v-if="local && local.endereco && (!!local.endereco.logradouro || (!!local.endereco.uf && !!local.endereco.cidade))">
        <div class="resumo-show_header--blue my-2">
          {{ (local.endereco.logradouro || local.endereco.uf && local.endereco.cidade) || 'Não informado' }}
        </div>
        <div class="pl-4 pl-4 row">
          <div class="col-10">
            <div class="row">
              <div class="col">
                <label class="resumo-show_header--label">CEP</label>
                <div class="resumo-show_header--sublabel">
                  {{ local.endereco.cep || 'Não informado' }}
                </div>
              </div>
              <div class="col">
                <label class="resumo-show_header--label">Número</label>
                <div class="resumo-show_header--sublabel">
                  {{ local.endereco.numero || 'Não informado' }}
                </div>
              </div>
              <div class="col">
                <label class="resumo-show_header--label">Complemento</label>
                <div class="resumo-show_header--sublabel">
                  {{ local.endereco.complemento || 'Não informado' }}
                </div>
              </div>
              <div class="col">
                <label class="resumo-show_header--label">Bairro</label>
                <div class="resumo-show_header--sublabel">
                  {{ local.endereco.bairro || 'Não informado' }}
                </div>
              </div>
              <div class="col">
                <label class="resumo-show_header--label">Cidade</label>
                <div class="resumo-show_header--sublabel">
                  {{ local.endereco.cidade || 'Não informado' }}
                </div>
              </div>
              <div class="col">
                <label class="resumo-show_header--label">UF</label>
                <div class="resumo-show_header--sublabel">
                  {{ local.endereco.uf || 'Não informado' }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </collapse-default>
</template>

<script>
  import CollapseDefault from "./CollapseDefault"

  export default {
    name: "DadosCasamentoCollapse",
    components: {
      CollapseDefault
    },
    props: {
      local: {
        type: Object,
        default: () => ({})
      },
      collapseVisible: {
        type: Boolean,
        default: false
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>
